
import { Component, Vue } from 'vue-property-decorator'
import { MenuAdd } from '@/types/menu'
import { ElForm } from 'element-ui/types/form'
import { pInteger } from '@/utils/validate'

@Component({
  name: 'MenuAdd'
})
export default class extends Vue {
  private title = '新增菜单'

  private info: MenuAdd = {
    menuName: '',
    url: '',
    iconPath: '',
    isLeaf: '',
    menuCommon: '',
    orderNum: '',
    parentMenuId: null,
    button: [],
    status: ''
  }

  private rules = {
    menuName: [{ required: true, message: '请输入菜单名称', trigger: ['blur', 'change'] }],
    parentMenuId: [{ required: true, message: '请选择父级菜单', trigger: ['change'] }],
    // iconPath: [{ required: true, message: '请输入图标名称', trigger: ['blur', 'change'] }],
    isLeaf: [{ required: true, message: '请选择是否叶子节点', trigger: ['change'] }],
    orderNum: [{ validator: pInteger, trigger: ['blur', 'change'] }]
  }

  private butCode = ''
  private butName = ''
  private menuList = []
  private submitShow = false
  private props = {
    children: 'childNode',
    label: 'menuName',
    value: 'menuId'
  }

  created () {
    this.menuListGet()
    if (this.$route.params.id) {
      this.title = '编辑菜单'
      this.detailsGet()
    }
  }

  // 详情
  detailsGet () {
    this.$axios.get(this.$apis.menu.menuDetails, {
      menuId: this.$route.params.id
    })
      .then((res) => {
        this.info = {
          menuName: res.menuName || '',
          url: res.url || '',
          iconPath: res.iconPath || '',
          isLeaf: res.isLeaf || '',
          menuCommon: res.menuCommon || '',
          parentMenuId: res.parentMenuId || '',
          orderNum: res.orderNum || '',
          button: res.button || [],
          status: res.status || '',
          menuId: res.menuId
        }
      })
  }

  // 菜单列表树状结构
  menuListGet () {
    this.$axios.get(this.$apis.menu.selectIparkMenuTreeList).then((res) => {
      this.menuList = res || []
    })
  }

  handleClose (index: never) {
    this.info.button.splice(index, 1)
  }

  // 添加按钮权限
  handleInputConfirm () {
    if (this.butCode && this.butName) {
      let codeRules = true
      this.info.button.forEach((item) => {
        if (item.butCode === this.butCode) {
          this.$message({
            message: 'Code重复',
            type: 'warning'
          })
          codeRules = false
        }
      })
      if (codeRules) {
        this.info.button.push({
          butCode: this.butCode,
          butName: this.butName
        })
        this.butCode = ''
        this.butName = ''
      }
    }
  }

  // 提交保存
  onSubmit () {
    (this.$refs.info as ElForm).validate((valid) => {
      if (valid) {
        this.submitShow = true
        // this.info.isLeaf === '1'
        //   ? ''
        //   : this.info.parentMenuId = null
        const url = this.$route.params.id
          ? this.$apis.menu.menuUpdate
          : this.$apis.menu.menuAdd
        this.$axios.post(url, this.info)
          .then(() => {
            this.submitShow = false
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$router.push({ name: 'menuSetting' })
          })
          .catch(err => {
            this.submitShow = false
            this.$message.error(err)
          })
      }
    })
  }
}
